import { createAction } from '@reduxjs/toolkit';
import { commonActions } from '@codametrix/ui-common';
import { api } from '../core/net';

const { Eula } = commonActions;

const saveEula = createAction<CMxAPI.Eula>(Eula.SAVE_EULA);

const getEula = async (userId: number, orgId: number) => {
  const eula = await api<CMxAPI.Eula>({
    endpoint: `/users/eula/v1?userId=${userId}&orgId=${orgId}`
  });

  return { ...eula };
};

export { getEula, saveEula };
